import React, { useState, useMemo } from 'react';

import Checkbox from 'dpl/form/components/Checkbox';
import { FILTER_DELIVERY_METHODS } from 'dpl/constants/query_params';
import useSearchQueryFilter from 'dpl/breeder_search_results/hooks/useSearchQueryFilter';
import { deliveryMethodOptionsResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import FilterDrawer from './FilterDrawer';
import TransportationModal from './TransportationModal';

export default function TransportationFilter() {
  const { searchQueryFilterValues, toggleFilter } = useSearchQueryFilter(
    FILTER_DELIVERY_METHODS
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    value: { data: deliveryMethods }
  } = useResourceQuery(deliveryMethodOptionsResourceDefinition(true));

  const sortedDeliveryMethods = useMemo(() => {
    return deliveryMethods.sort((dm1, dm2) => dm1.position - dm2.position);
  }, [deliveryMethods]);

  function handleOpenModalClick(e) {
    e.stopPropagation();
    setIsModalOpen(true);
  }

  function handleCloseModalClick() {
    setIsModalOpen(false);
  }

  return (
    <FilterDrawer
      className="BreederSearchResultsTransportationFilter"
      title="Transportation"
    >
      {sortedDeliveryMethods.map(({ id, name }) => (
        <div key={id} className="mb4">
          <Checkbox
            key={id}
            id={`${FILTER_DELIVERY_METHODS}_${id}`}
            name={name}
            title={name}
            value={id}
            checked={searchQueryFilterValues.includes(Number(id))}
            onChange={e => toggleFilter(Number(e.target.value))}
          />
        </div>
      ))}
      <div className="bg-lightest-purple w-100 ph4 pv2 br3 f2">
        <button onClick={handleOpenModalClick} className="purple" type="button">
          Learn more
        </button>{' '}
        about our safe transportation methods.
      </div>

      {isModalOpen && (
        <TransportationModal onCloseClick={handleCloseModalClick} />
      )}
    </FilterDrawer>
  );
}
